/* tslint:disable */
/* eslint-disable */
/**
 * Portal Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PostFeedbackRequest interface.
 */
export function instanceOfPostFeedbackRequest(value) {
    return true;
}
export function PostFeedbackRequestFromJSON(json) {
    return PostFeedbackRequestFromJSONTyped(json, false);
}
export function PostFeedbackRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'flowRunId': json['flow_run_id'] == null ? undefined : json['flow_run_id'],
        'isLike': json['is_like'] == null ? undefined : json['is_like'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
export function PostFeedbackRequestToJSON(json) {
    return PostFeedbackRequestToJSONTyped(json, false);
}
export function PostFeedbackRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'flow_run_id': value['flowRunId'],
        'is_like': value['isLike'],
        'comment': value['comment'],
    };
}
